import { render, staticRenderFns } from "./BusinessStatistics.vue?vue&type=template&id=8739a74e&"
import script from "./BusinessStatistics.vue?vue&type=script&lang=js&"
export * from "./BusinessStatistics.vue?vue&type=script&lang=js&"
import style0 from "./BusinessStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports